<template>
  <div class="merchant-detail-container">
    <template v-if="!$isMobile">
      <div class="detail-container__swiper-container" ref="wrapper" v-if="detail && detail.type === 1">
        <swiper class="swiper__wrapper" ref="merchantDetailSwiper" :options="swiperOptions"
          v-if="!pageLoading && detail && detail.banner_ids.length > 0">
          <swiper-slide class="swiper-container--slide" v-for="(img, index) in detail.banner_ids" :key="index"
            ref="slides">
            <div class="img" :style="{ backgroundImage: `url(${bgUrl(img)})` }"></div>
          </swiper-slide>
        </swiper>
        <div class="swiper__direction-bts">
          <div class="bts__item --prev icon icon-svg-arrow-left" ref="prev"></div>
          <div class="bts__item --next icon icon-svg-arrow-right" ref="next"></div>
        </div>
      </div>
    </template>
    <template v-else>
      <detail-swiper v-if="detail && detail.type === 1 && !pageLoading && detail && detail.banner_ids.length > 0"
        :pictures="detail.banner_ids" enable-preview></detail-swiper>
    </template>
    <div class="detail-container__base-info-container --detail-merchant" v-if="detail">
      <div class="base-info__wrapper">
        <template v-if="!$isMobile">
          <div class="base-info__info">
            <div class="info__wrapper">
              <div class="info__mix">
                <div class="info__logo">
                  <img :src="detail.logo_picture_url | parseImage" alt />
                </div>
                <div class="bt__item-c">
                  <span class="btn-s yuanjiao" @click="checkoutPdf">查看资料</span>
                  <span class="btn-s yuanjiao" v-if="userInfo.type == 1 || userInfo.type == 4"
                    @click="onWacth(detail)">企业宣讲视频</span>
                  <span class="btn-s yuanjiao" @click="onCertificate(detail)">企业资质</span>
                  <span class="btn-s yuanjiao" @click="onTie(detail)">产品贴图下载</span>
                </div>
              </div>
              <div class="info__text">
                <div class="text__name">{{ detail.name }}</div>
                <sign v-if="detail.type == 1 && detail.sign > 0" :sign="detail.sign" class="sp-sign"></sign>
                <div class="text__type" style="margin-top: 0.7vw !important">
                  <p class="type__text">{{ detail.type === 1 ? "厂家直营店" : "认证经销商" }}</p>
                  <el-rate class="type__rate" disabled v-model="detail.level"></el-rate>
                </div>
                <div class="text__type">
                  <p class="type__text">{{ "优质案例率" }}</p>
                  <el-rate class="type__rate" disabled v-model="detail.beContactedStar"></el-rate>
                </div>
                <div class="text__type">
                  <p class="type__text">{{ "被设计联系" }}</p>
                  <el-rate class="type__rate" disabled v-model="detail.highQualityStar"></el-rate>
                </div>
                <!-- <div class="text__bts">
                  <div class="bt__item" v-for="(c, index) in belongLocal" :key="index">{{ c }}</div>
                </div> -->
              </div>
            </div>
          </div>
          <div class="base-info__text">
            <div class="text__summary">{{ detail.content }}</div>
            <el-collapse-transition>
              <div class="text__more-detail-info" v-show="infoShow">
                <div class="info__row transition-box" v-if="detail.address">
                  <span>Add_</span>
                  {{ detail.address }}
                </div>
                <div class="info__row transition-box" v-if="detail.phone">
                  <span>Mob_</span>
                  {{ detail.phone }}
                  <a class="yellow see-tel" @click="checkTel(detail.id, detail.phone)">查看电话</a>
                  <a class="see-tel" v-if="userInfo && userInfo.isMerchant && !userInfo.isAuthMerchant"
                    @click="checkoutphone">查看电话</a>
                </div>
                <a class="info__row transition-box" v-if="detail.url_address" :href="`http://${detail.url_address}`"
                  target="_blank">
                  <span>Web_</span>
                  {{ detail.url_address }}
                </a>
                <a href="javascript:void(0);" v-if="userInfo && userInfo.isMerchant && !userInfo.isAuthMerchant"
                  @click="onClaim" class="--blue">认领/入驻</a>
              </div>
            </el-collapse-transition>
            <div class="text__showmore" @click="infoShow = !infoShow">
              {{ infoShow ? "-收起更多信息" : "+展开更多信息" }}
            </div>
          </div>
        </template>
        <template v-else>
          <div class="mobile-detail-parameters-container">
            <div class="detail-store-info detail__child">
              <div class="store-logo">
                <div class="__logo">
                  <img :src="detail.logo_picture_url | parseImage" alt />
                </div>
              </div>
              <div class="store-info">
                <div class="info__item">{{ detail.name }}</div>
                <div class="info__item">
                  <p class="type__text">
                    {{
                      Number(detail.type) === 2
                      ? "认证经销商"
                      : Number(detail.type) === 1
                        ? "厂家直营店"
                        : ""
                    }}
                  </p>
                  <el-rate class="type__rate" disabled v-model="detail.level"></el-rate>
                </div>
                <div class="info__item">{{ belongLocal.join(",") }}</div>
              </div>
            </div>
            <div class="detail-merchant-info detail__child">
              <div class="info__summary">{{ detail.content }}</div>
              <div class="info__other">
                <p>
                  <span>add_</span>
                  {{ detail.address }}
                </p>
                <p>
                  <span>mob_</span>
                  {{ detail.phone }}
                </p>
                <p v-if="detail.url_address">
                  <span>web_</span>
                  {{ detail.url_address }}
                </p>
              </div>
            </div>
          </div>
        </template>

        <!-- 如果是经销商显示进入店铺 -->
        <!-- <router-link
          :to="{
            path: `/merchant/${detail.pid}/cases`
          }"
          v-if="detail && detail.type === 2 && detail.pid > 0"
          class="base-info__jump-to-store"
        >
          进入店铺
        </router-link>-->
        <a v-if="detail && detail.type === 2 && detail.pid > 0" class="base-info__jump-to-store" :href="'https://store.clzx.net/index.php?ctl=Join&met=cf_jump&type_id=2&user_id=' +
          userInfo.id +
          '&store_id=' +
          detail.id
          " target="_blank">进入店铺</a>
      </div>
      <!-- 经销商信息 -->
      <template v-if="detail.distributorList && detail.distributorList.length > 0 && !$isMobile">
        <div class="info__dealar-container">
          <div class="info__dealar-title">服务商</div>
          <div class="info__dealar-lists">
            <div class="dealer-card-container" v-for="(list, indexxxx) in detail.distributorList" :key="indexxxx">
              <div class="card__inner">
                <div class="card__title">服务商</div>
                <div class="card__main-body">
                  <div class="main-body__wrapper">
                    <div class="main-body__children logo">
                      <img :src="list.logo_picture_url | parseImage" alt />
                    </div>
                    <div class="main-body__children">
                      <p>{{ list.name }}</p>
                      <p>
                        <i class="icon icon-view"></i>
                        <span>{{ list.browsenums }}</span>
                      </p>
                    </div>
                    <div class="main-body__children">
                      <p>
                        <i class="icon icon-located"></i>
                        <span>{{ list.provArr["0"] }}</span>
                      </p>
                      <!-- <router-link
                        class="link"
                        :to="{
                          path: `/merchant/${list.id}/cases`
                        }"
                        >进入店铺</router-link
                      >-->
                      <!-- {{'https://store.clzx.net/index.php?ctl=Join&met=cf_jump&type_id=2&user_id='+userInfo.id + '&store_id=' + list.id}} -->
                      <a class="link" :href="'https://store.clzx.net/index.php?ctl=Join&met=cf_jump&type_id=2&user_id=' +
                        userInfo.id +
                        '&store_id=' +
                        list.id
                        " target="_blank">进入店铺</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="detail-container__main-body">
      <div class="main-body__nav-container">
        <div class="nav-container__wrapper">
          <router-link :to="nav.url" class="nav-item" v-for="(nav, index) in merchantNav" :key="index"
            active-class="merchant-link-active">
            <div v-if="nav.name == '商城店铺'">
              <button style="background-color: #fabe00; border-radius: 20px; height: 30px; width: 95px">
                {{ nav.name }}
              </button>
            </div>
            <div v-else>{{ nav.name }}（{{ counts[nav.sign] }}）</div>
          </router-link>
        </div>
      </div>
      <div class="main-body__main-info-container">
        <router-view v-if="detail" :detail="detail"></router-view>
      </div>
    </div>
    <el-dialog custom-class="tb-dialog" title="提示" :visible.sync="dialogVisible" width="30%">
      <span>是否将需求同步至需求板块</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="(dialogVisible = false), checkTel(detail.id, detail.phone)">不用</el-button>
        <el-button type="primary" @click="(dialogVisible = false), onSubmit(params)">同步并查看电话</el-button>
      </span>
    </el-dialog>
    <el-dialog custom-class="img-dialog" title="资质证书" :visible.sync="imgVisible" width="80%">
      <el-image style="height: 666px" :src="imgUrl | parseImage" fit="contain"></el-image>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imgVisible = false">关闭</el-button>
        <!-- <el-button type="primary"><a :href="imgUrl" download="1.png" target="_blank">下载</a></el-button> -->
      </span>
    </el-dialog>
    <el-dialog custom-class="tb-dialog" title="产品贴图下载链接" :visible.sync="tieVisible" width="30%">
      <span>链接：</span>
      <span>{{ detail && detail.mapping_share }}</span>
      <!-- <p style="margin-top: 10px;">提取码：{{ detail.mapping_share }}</p> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="tieVisible = false">关闭</el-button>
        <el-button type="primary" v-clipboard:copy="detail && detail.mapping_share" v-clipboard:success="onCopy"
          v-clipboard:error="onError">复制</el-button>
      </span>
    </el-dialog>
    <el-dialog custom-class="tel-dialog" title="推荐商户" :visible.sync="telVisible" width="1000px">
      <div class="cart__main-body">
        <table class="gridtable">
          <tr>
            <th class="spec" width="50px">序号</th>
            <th class="spec" width="300px">商户名称</th>
            <th class="spec" width="150px">联系人</th>
            <th class="spec" width="150px">联系电话</th>
            <th class="spec" width="358px">商户信息</th>
            <!-- <th class="spec">操作</th> -->
          </tr>
          <tr v-for="(item, index) in telList" :key="index">
            <td class="spec" style="text-align: left">{{ index + 1 }}</td>
            <td class="spec" style="text-align: left">
              <p style="margin-bottom: 8px">{{ item.name }}</p>
            </td>
            <td class="spec" style="text-align: left">
              <p>{{ item.contact }}</p>
            </td>
            <td style="text-align: left">
              <p>{{ item.phone }}</p>
            </td>
            <td class="spec" style="text-align: left">
              <p class="ellipsis1">{{ item.content }}</p>
            </td>

            <!-- <td class="spec" style="text-align: center;">
                  <el-button class="black"  :data-id="item.id" size="mini" @click="onTel(item)">拨打电话</el-button>
            </td>-->
          </tr>
        </table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="telVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <addRequirement ref="addRequirement" />
  </div>
</template>

<script>
import { create, getDemandForRandomStoreList } from "@/api/requirement";
import { checkoutLogin } from "@/assets/utils/handler";
import { parseImage } from "@/filters";
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";

import { reduceIntegral, getStorePhone } from "@/api/store";
import { getCallMessage, userActionLog } from "@/api/user";
import { USER_ACTION_MAP } from "@/assets/utils/dict";
import DetailSwiper from "@/pages/common/detailSwiper.vue";
import formComp from "@/pages/common/form.vue";
import Sign from './_sign.vue'

import clipboard from "clipboard";
import addRequirement from "./addRequirement";

export default {
  components: {
    Swiper,
    SwiperSlide,
    DetailSwiper,
    formComp,
    addRequirement,
    Sign
  },
  data() {
    return {
      stars: 5,
      showAddRequirement: false,
      dialogVisible: false,
      infoShow: true,
      detail: null,
      phoneShow: false,
      cases: null,
      produsts: null,
      samples: null,
      articles: null,
      relatedCases: null,
      swiperOptions: {
        autoplay: true,
        speed: 700,
        centeredSlides: true,
        spaceBetween: 0,
        slidesOffsetBefore: 0,
        loop: true,
        slidesPerView: "auto",
        navigation: {
          nextEl: ".swiper__direction-bts .--next",
          prevEl: ".swiper__direction-bts .--prev",
        },
        on: {
          init() {
            const bodyBCR = document.body.getBoundingClientRect();
            const aBCR = document.querySelector(".swiper-slide-active").getBoundingClientRect();
            const directBts = Array.from(document.querySelectorAll(".bts__item"));
            const width = Math.floor((bodyBCR.width - aBCR.width) / 2);
            for (let i = 0; i < directBts.length; i += 1) {
              directBts[i].style.width = `${width}px`;
            }
            directBts[1].style.left = `${width + aBCR.width}px`;
          },
        },
      },
      swiper: null,
      counts: {
        cases: 0,
        products: 0,
        samples: 0,
        articles: 0,
        idid: 0,
        dynamics: 0,
        xystore: 0,
        chartlet: 0,
      },
      info: {
        phone: "",
        store_id: 100,
      },
      pageSize: 15,
      imgVisible: false,
      tieVisible: false,
      imgUrl: "",
      telVisible: false,
      telList: [],
      phone: "",
    };
  },
  computed: mapState({
    cities: (state) => state.cities,
    userInfo: ({ user: { info } }) => info,
    pageLoading: (state) => state.pageloading,
    merchantNav() {
      if (this.detail && this.detail.type === 1) {
        return [
          {
            name: "案例",
            url: `/merchant/${this.id}/cases`,
            sign: "cases",
          },
          {
            name: "产品",
            url: `/merchant/${this.id}/products`,
            sign: "products",
          },
          // {
          //   name: '样品',
          //   url: `/merchant/${this.id}/samples`,
          //   sign: 'samples',
          // },
          {
            name: "商城店铺",
            url: `/merchant/${this.id}/xystore`,
            sign: "xystore",
          },
          {
            name: "文章",
            url: `/merchant/${this.id}/articles`,
            sign: "articles",
          },
          {
            name: "动态",
            url: `/merchant/${this.id}/dynamics`,
            sign: "dynamics",
          },
          // {
          //   name: '产品贴图',
          //   url: `/merchant/${this.id}/chartlet`,
          //   sign: 'chartlet',
          // },
        ];
      }
      if (this.detail && this.detail.type !== 1) {
        return [
          {
            name: "案例",
            url: `/merchant/${this.id}/cases`,
            sign: "cases",
          },
          {
            name: "产品",
            url: `/merchant/${this.id}/products`,
            sign: "products",
          },
          {
            name: "动态",
            url: `/merchant/${this.id}/dynamics`,
            sign: "dynamics",
          },
        ];
      }
      return [];
    },
    id() {
      return this.$route.params.id;
    },
    type() {
      return this.$route.params.type;
    },
    page() {
      return this.$route.query.page || 1;
    },
    belongLocal() {
      const provIds =
        this.detail.prov_id.indexOf(",") >= 0
          ? this.detail.prov_id.split(",")
          : [this.detail.prov_id];
      if (this.cities) {
        const prov =
          Number(this.detail.prov_id) === 0
            ? ["全国"]
            : provIds.map((item) => {
              const temp = this.cities.find((c) => Number(c.id) === Number(item));
              return temp.name;
            });
        return prov;
      }
      return [];
    },
  }),
  watch: {
    $route: {
      handler() {
        this.getmore();
      },
      immediate: true,
    },
    id: {
      handler() {
        this.init();
      },
      immediate: true,
    },
    detail(val) {
      if (val && val.user_id && val.user_id > 0) {
        this.getDynamic({
          id: val.user_id,
          page: this.page,
          page_size: this.pageSize,
        });
      }
    },
    telVisible(val) {
      if (!val) {
        this.dialogVisible = true;
      }
    },
    tieVisible(val) {
      document.body.oncopy = function () {
        return val;
      };
    },
  },
  created() {
    // this.init();
    console.log('created')
  },
  mounted() {
    const that = this;
    this.$nextTick(() => {
      const header = document.querySelector(".header-wrapper-container");
      if (that && that.type === 1) {
        header.classList.add("isFixed");
      }
    });
    document.oncontextmenu = function () {
      return false;
    };
  },
  updated() {
    // const that = this;
    // this.$nextTick(() => {
    //   console.log(window.innerWidth, document.body.clientWidth, document.body.offsetWidth);
    //   console.log(document.querySelector('.page-common-main-container').getBoundingClientRect());
    //   that.$refs.merchantDetailSwiper.$swiper.init();
    // that.initD();
    // });
  },
  destroyed() {
    document.oncontextmenu = function () {
      return true;
    };
  },
  methods: {
    initD() {
      const bodyBCR = document.body.getBoundingClientRect();
      const aBCR = document.querySelector(".swiper-slide-active").getBoundingClientRect();
      const directBts = Array.from(document.querySelectorAll(".bts__item"));
      const width = Math.floor((bodyBCR.width - aBCR.width) / 2);
      for (let i = 0; i < directBts.length; i += 1) {
        directBts[i].style.width = `${width}px`;
      }
      directBts[1].style.left = `${width + aBCR.width}px`;
    },
    init() {
      this.detail = null;
      // 获取第一批数据
      this.$store.commit("openLoading");
      const pagination = {
        id: this.id,
        page: this.page,
        page_size: this.pageSize,
      };
      const requests = [
        this.getDetail(),
        this.getCases(pagination),
        this.getProducts(pagination),
        this.getSamples(pagination),
        this.getArticle(pagination),
        this.getRelatedCase(pagination),
        this.getXyStore(pagination),
      ];
      this.$http
        .multi(requests)
        .then((res) => {
          this.detail = res["0"].data;
          this.counts.cases = res["1"].data.total.num;
          this.counts.products = res["2"].data.total.num;
          this.counts.samples = res["3"].data.total.num;
          this.counts.articles = res["4"].data.total.num;
          this.counts.idid = res["5"].data.total.num;
          // this.counts.xystore = res['6'].data.total.num;
        })
        .finally(() => {
          this.$store.commit("closeLoading");
        });
    },
    bgUrl(val) {
      return parseImage(val);
    },
    getmore() {
      //console.log('getmore');
    },
    getDetail() {
      return this.$http.post("html/store/storeDetail", {
        id: this.id,
      });
    },
    getCases(data) {
      return this.$http.post("html/store/storeCase", data);
    },
    getProducts(data) {
      return this.$http.post("html/store/storeProduct", data);
    },
    getSamples(data) {
      return this.$http.post("html/store/storeSample", data);
    },
    getRelatedCase(data) {
      return this.$http.post("html/store/storeRelevant", data);
    },
    getArticle(data) {
      return this.$http.post("html/store/storeArticle", data);
    },
    getDynamic(data) {
      this.$http.post("html/Publiccon/businessDynamic", data).then((res) => {
        const { list } = res.data;
        this.counts.dynamics = list.length;
      });
    },
    getXyStore(data) { },
    onClaim() {
      userActionLog({
        type: USER_ACTION_MAP.auth,
      });
      checkoutLogin();
    },
    async checkTel(id, phone) {
      if (
        (this.userInfo.type == 1 || this.userInfo.type == 2) &&
        (this.detail.type == 1 || this.detail.type == 2)
      ) {
        this.$message({
          type: "error",
          message: "您当前账户角色不支持查看",
        });
        return;
      }
      this.phone = phone;
      // this.getDemandForRandomStoreList();
      // return;
      try {
        const result = await getCallMessage({
          id,
        });
        if (result.success === true && result.errorcode === "10000") {
          this.seeTel(id, phone);
        } else {
          getStorePhone(this.id).then((res) => {
            if (res.success == true && res.data.phone != "") {
              this.showmsgs(res.data.phone);
            }
          });
        }
        if (result.errorcode == "200050") {
          this.$message({
            type: "error",
            message: result.desc,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    showmsgs(phone) {
      let that = this;
      this.$layer.confirm(
        "商户电话:" + phone,
        {
          title: "查看商户电话信息",
          btn: ["确定", "取消"], //按钮
        },
        function () {
          //点击确定访问后台
          that.$layer.closeAll();
        },
        function () {
          //点击取消则中断操作
          that.$layer.closeAll();
          //that.$layer.msg('已取消');
        }
      );
    },
    seeTel(ids, phone) {
      const that = this;
      that.info.store_id = ids;

      that.info.phone = phone;
      const id = that.$layer.iframe({
        content: {
          content: formComp,
          parent: that,
          data: {
            info: that.info,
            fn: () => {
              //alert(2110);
            },
            successFun: (params) => {
              this.params = params;
              that.dialogVisible = true;
              // this.getDemandForRandomStoreList()
            },
          },
        },
        area: ["688px", "558px"],
        title: "填写信息即可以拨打电话",
        maxmin: false,
        shade: true,
        shadeClose: true,
        scrollbar: true,
        resize: true,
        cancel: () => {
          //alert(2110);
        },
      });
      //that.$layer.full(id);
    },
    checkoutPdf() {
      if (checkoutLogin()) {
        if (!this.onCheck()) return;
        if (this.detail.file_url === "") {
          this.$message({
            type: "info",
            message: "该店铺暂未上传资料",
          });
        } else {
          // console.log(this.userInfo, 'userInfo')
          if (this.userInfo.identity == 4) {
            this.$confirm("设计企业店铺才可查看", "提示", {
              confirmButtonText: "注册设计企业",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.$router.push("/my/authDisign");
              })
              .catch(() => { });
            return;
          }
          if (this.userInfo.type == 4) {
            this.setStoreLook();
            reduceIntegral(this.detail.id, 28).then((res) => {
              if (res.success == true) {
                window.open(parseImage(this.detail.file_url));
              } else {
                this.$message({
                  type: "error",
                  message: res.data.desc,
                });
              }
            });
          } else {
            this.$message({
              type: "error",
              message: "仅设计企业查看或下载",
            });
          }
        }
      }
    },
    checkoutphone() {
      checkoutLogin();
    },
    //统计店铺 被查看
    setStoreLook() {
      this.$http.post("html/store/setStoreLook", { id: this.detail.id });
    },
    onWacth(store) {
      if (!this.onCheck()) return;
      // console.log(store, 66)
      if (store.past_video_url) {
        this.$http.post("html/store/lookPastVideo", {
          id: store.id,
        });
        window.open(store.past_video_url);
      } else {
        this.$message({
          type: "error",
          message: "该商家还没有上传视频",
        });
      }
    },
    async onSubmit(val) {
      let formData = val;
      delete formData.store_id;
      try {
        await create(formData);
        this.$message({
          type: "success",
          message: "同步成功",
        });
        getStorePhone(this.id).then((res) => {
          if (res.success == true && res.data.phone != "") {
            this.showmsgs(res.data.phone);
          }
        });
        // this.getDemandForRandomStoreList()
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    },
    async getDemandForRandomStoreList() {
      this.telVisible = true;
      this.telList = [];
      let params = {
        limit_num: 10,
        mold_id: this.detail.mold_id,
        mold_ids: this.detail.mold_ids,
      };
      try {
        let data = await getDemandForRandomStoreList(params);
        console.log(data.data.list, 898);
        this.telList = data.data.list;
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    },
    onCertificate(detail) {
      if (!this.onCheck()) return;
      // detail.qualifications_url =
      //   "http://clzx.ameyoc.com/uploads/images/20220221/fb4d4dc98fc494bf346a548f62f2ba81.gif";
      if (!detail.qualifications_url) {
        this.$message({
          type: "error",
          message: "该商家还没有上传资质证书",
        });
        return;
      }
      if (this.userInfo.identity == 8) {
        reduceIntegral(this.detail.id, 30).then((res) => {
          if (res.success == true) {
            this.imgVisible = true;
            this.imgUrl = detail.qualifications_url;
          } else {
            this.$message({
              type: "error",
              message: res.data.desc,
            });
          }
        });
      } else {
        this.$message({
          type: "error",
          message: "仅设计企业查看和下载",
        });
      }
      console.log(clipboard, 66, this.userInfo);
    },
    onTie(detail) {
      if (!this.onCheck()) return;
      // detail.mapping_share =
      //   "http://clzx.ameyoc.com/uploads/images/20220221/fb4d4dc98fc494bf346a548f62f2ba81.gif";
      if (!detail.mapping_share) {
        this.$message({
          type: "error",
          message: "该商家还没有上传产品贴图",
        });
        return;
      }
      reduceIntegral(this.detail.id, 31).then((res) => {
        if (res.success == true) {
          this.tieVisible = true;
        } else {
          this.$message({
            type: "error",
            message: res.data.desc,
          });
        }
      });
    },
    onCopy(e) {
      console.log("复制成功！");
      this.$message({
        type: "success",
        message: "复制成功！",
      });
      this.tieVisible = false;
    },
    onError(e) {
      console.log("复制失败！");
    },
    onTel(item) { },
    onCheck() {
      if (this.userInfo.type != 4) {
        this.$message({
          type: "error",
          message: "仅设计企业才能查看",
        });
      }
      return this.userInfo.type == 4;
    },
  },
};
</script>

<style lang="scss">
.merchant-detail-container .detail-container__base-info-container .base-info__text .text__more-detail-info a.see-tel {
  background-color: #fabe00;
  cursor: pointer;
  color: #ffffff;
  transition: 0.1s;
  font-weight: 500;
  font-size: 12px;
  border-radius: 4px;
}

.yellow {
  background-color: #fabe00;
  color: #ffffff;
  margin-right: 18px;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 60px auto;
  width: 800px;
}

.el-button--primary {
  color: #fff;
  background-color: #fabe00;
  border-color: #fabe00;
}

.v-modal {
  z-index: 0 !important;
}

.merchant-detail-container {
  .tb-dialog {
    margin-top: 35vh !important;
  }

  .bt__item-c {
    width: calc(200% + 20px);
    margin-top: 0.78125vw;

    .btn-s {
      width: calc(50% - 10px);
      text-align: center;
      background: #fabe00;
      color: #000;
      line-height: 1.5vw;
      cursor: pointer;
      display: inline-block;
      margin-right: 10px;
      margin-bottom: 10px;

      &:last-child {
        margin-right: 8px;
      }
    }
  }

  .info__text {
    min-height: unset !important;

    .text__type {
      margin-top: 0.2vw !important;

      .type__text {
        min-width: 72px;
        width: 4.3vw;
      }
    }
  }

  .tel-dialog {
    .tel-dia-c {
      max-height: 666px;
      overflow-y: auto;
    }

    .item-c {
      border-bottom: 1px solid #eee;
      padding: 10px 0;

      &:last-child {
        border-bottom: unset;
      }
    }

    .item-center-c {
      width: 66%;

      h3 {
        margin-bottom: 6px;
      }
    }

    .el-button--mini {
      height: 30px;
    }
  }

  .gridtable {

    td,
    th {
      text-align: left;
    }
  }
}

.img-dialog {
  max-width: 994px;

  .el-dialog__body {
    text-align: center;
  }
}

.yuanjiao {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.sp-sign {
  margin: 0.7vw 0 0 0 !important;
}
</style>
